import React from 'react';

import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    Stack,
    List,
    ListItem,
    ListItemText,
    Typography
} from '@mui/material';

const PropertyNotesModal = ({ propertyNotes, onClose }) => {
    return (
        <Stack>
            <DialogTitle>Property Notes!</DialogTitle>
            <Divider />
            <DialogContent sx={{ p: 2.5 }}>
                <Grid container columnSpacing={2}>
                    <Grid item xs={12} sm={12}>
                        <Stack sx={{ height: '30vh', width: '100%' }}>
                            <List
                                sx={{
                                    width: '100%',
                                    overflowY: 'auto',
                                    maxHeight: '30vh',
                                    padding: 0,
                                    margin: 0
                                }}
                            >
                                {propertyNotes.map(note => (
                                    <ListItem
                                        key={note.content}
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'flex-start',
                                            alignItems: 'center',
                                            width: '100%',
                                            backgroundColor: '#ffffff',
                                            borderBottom:
                                                '1px solid rgba(243, 243, 243, 1)',
                                            paddingLeft: '3%'
                                        }}
                                        disableGutters
                                    >
                                        <ListItemText
                                            sx={{
                                                maxWidth: '40%!important',
                                                left: '4%'
                                            }}
                                            primary={
                                                <Typography
                                                    sx={{
                                                        fontSize: '13px',
                                                        textTransform: 'capitalize'
                                                    }}
                                                    component="span"
                                                    variant="body1"
                                                    color="text.primary"
                                                    title={note.content}
                                                >
                                                    {`- ${note.content}`}
                                                </Typography>
                                            }
                                        />
                                    </ListItem>
                                ))}
                            </List>
                        </Stack>
                    </Grid>
                </Grid>
            </DialogContent>
            <Divider />
            <DialogActions sx={{ p: 2.5 }}>
                <Grid container justifyContent="space-between" alignItems="center">
                    <Grid item>
                        <Stack direction="row" spacing={2} alignItems="center">
                            <Button type="submit" variant="contained" onClick={onClose}>
                                Close
                            </Button>
                        </Stack>
                    </Grid>
                </Grid>
            </DialogActions>
        </Stack>
    );
};

export default PropertyNotesModal;
